




























































import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import CreativeSpaceBindSelector from '@ui/ResourceBindSelector/CreativeSpaceBindSelector'
import Modal from '@components/Modal'

settings =
  name: 'InventoryStep'

  resources:
    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:wizard.supplierId/audience_availabilities'
      params:
        quick_list: true

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      CreativeSpaceBindSelector,
      Modal,
    }

    data: ->
      missingSpacesModal:
        show: false
        stepName: null
      missingCapacityModal:
        show: false
        stepName: null

    computed:
      optionsForBindSelector: ->
        supplierId: @wizard.supplierId

      displayInventoryEmptyState: ->
        return true unless @wizard.audienceCreativeData.stats.dates_count > 0
        return true unless @wizard.audienceCreativeData.stats.availabilities_count > 0
        false

      displayConfirmModal: ->
        return true if @wizard.audienceCreativeData.stats.spaces_count is 0
        return true if @spacesMissingCapacity.length > 0
        false

      spacesMissingCapacity: ->
        @wizard.creativeSpaces.filter((space) =>
          space.availability_ids.some((availabilityId) =>
            availability = (@availabilities || []).find((av) => av.id is availabilityId)
            return false unless availability
            return false if space.segment_renamed
            switch space.type
              when 'product_sampling'
                @isEmptyValue availability.engagement_capacity[space.segment]?.sampling_capacity
              when 'onsite_space'
                @isEmptyValue availability.engagement_capacity[space.segment]?.reach
              when 'omnichannel'
                false
          )
        )

      nationalOmnichannelCount: ->
        @ctxOmnichannel(@wizard.audienceCreativeData).national_omnichannel_count || 0

    mounted: ->
      { spaceId, ...query } = @$route.query
      @$router.replace { query }
      @wizard.fetchAudienceCreative()

    methods:
      hiChangeSpaceBindSelector: ->
        @wizard.fetchAudienceCreative()
        @wizard.fetchSpaces()

      hiEditSpace: (space) ->
        switch space.type
          when 'product_sampling'
            @wizard.navToStepName 'sampling-space-edit'
            @$router.replace { query: { ...@$route.query, spaceId: space.id }}
          when 'onsite_space'
            @wizard.navToStepName 'onsite-space-edit'
            @$router.replace { query: { ...@$route.query, spaceId: space.segment }}
          when 'omnichannel'
            @wizard.navToStepName 'omnichannel-space-edit'
            @$router.replace { query: { ...@$route.query, spaceId: space.id }}

      hiSetVenues: (space) ->
        @wizard.setContainerSelectorToScroll '.bind-venues-section'
        @hiEditSpace space

      hiConfirmModal: (stepName) ->
        if @wizard.audienceCreativeData.stats.spaces_count is 0
          @missingSpacesModal.show = true
          @missingSpacesModal.stepName = stepName
          return

        if @spacesMissingCapacity.length > 0
          @missingCapacityModal.show = true
          @missingCapacityModal.stepName = stepName
          return

    watch:
      requestIsPending: (value) ->
        @wizard.hideWaitingModal() unless value

export default VueOptions.vue settings
